/* Assets */
import { WALLET, ACCOUNTS_NIB_IBAN_GENERIC } from '@/assets/constants/masks'
import { lineGroupIconMapper } from '@/assets/scripts/mappers/genericDetail'
import { amountFormat, currencyParser } from '@/assets/scripts/amounts'
import { getDateWithTime } from '@/assets/scripts/dateBuilders'

export const parseLineGroups = (data, statusIconSvgName, statusIconColor, forceNegativeAmount, statusDescription) => {
    return data.reduce((acc, lineGroup) => {
        if (!lineGroup.lineGroup.shouldDisplay) return acc

        const tempLineGroup = {
            ...lineGroup.lineGroup,
            icon: lineGroupIconMapper(lineGroup.lineGroup.iconId), // still needs mapper to apply right icon
            lines: lineGroup.lines.map(line => {
                const tempLine = {
                    ...line,
                    label: line.lineLabel,
                    content: line.lineValue,
                    classes: line.lineValue.includes(' ') ? 'break-word' : 'break-all'
                }
                /*
                * all values and what they represent for lineTypes
                * NAME_VALUE(0), RICH_TEXT(1), AMOUNT(2), SECTION(3), DATE(4), DECIMAL_NUMBER(5),
                * NUMBER(6), BOOLEAN(7), PHONE_NUMBER(8), CURRENCY(9), HEADER(10), NBA(11), IBAN(12), EMAIL(13), BALANCE_AMOUNT(14), STATUS(15), ACCOUNT_NUMBER(16)
                */
                switch (line.lineType) {
                case 2:
                    // the numeric symbol changes depending on the param */
                    tempLine.icon = line.lineDecimal !== 0 ? (line.lineDecimal < 0 || forceNegativeAmount ? 'arrow-down-full' : 'arrow-up-full') : ''
                    tempLine.colorIconPreset = line.lineDecimal !== 0 ? (line.lineDecimal < 0 || forceNegativeAmount ? 'negative' : 'positive') : null
                    tempLine.content = amountFormat(Math.abs(line.lineDecimal), line.lineCurrency)
                    tempLine.classes = 'amount-icon'
                    break
                case 4:
                    tempLine.content = getDateWithTime(line.lineDate)
                    tempLine.classes = 'capitalize'
                    break
                case 6:
                    tempLine.content = line.lineNumber
                    break
                case 8:
                    tempLine.content = line.linePhone.trim().length ? line.linePhone : '-'
                    break
                case 9:
                    tempLine.content = currencyParser(line.lineCurrency)
                    break
                case 14:
                    // the numeric symbol changes depending on the param */
                    tempLine.icon = line.lineDecimal !== 0 ? (line.lineDecimal > 0 ? 'plus' : 'minus') : ''
                    tempLine.colorIconPreset = line.lineDecimal !== 0 ? (line.lineDecimal > 0 ? 'positive' : 'negative') : null
                    tempLine.content = amountFormat(Math.abs(line.lineDecimal), line.lineCurrency)
                    tempLine.classes = 'amount-icon'
                    break
                case 15:
                    if (statusIconSvgName) {
                        tempLine.icon = statusIconSvgName
                        tempLine.colorIcon = statusIconColor
                        tempLine.colorIconPreset = statusIconColor
                    }

                    if (statusDescription) tempLine.content = statusDescription
                    break
                case 16:
                    tempLine.mask = line.lineValue.includes('DW') ? WALLET : ACCOUNTS_NIB_IBAN_GENERIC
                    break
                }

                return tempLine
            })
        }

        acc.push(tempLineGroup)
        return acc
    }, [])
}
